export default {
  title: 'Astrochingolo',
  subtitle: 'Análisis de riesgos para ciudades del hoy y del mañana',
  riskIndex: '📊 Índice de Riesgo',
  mapDescription: 'Mapa interactivo',
  viewMap: '🗺️ Ver Mapa'
}
